import { h } from '@stencil/core';
export class RangeInfo {
  constructor() {
    this.image = undefined;
    this.name = undefined;
    this.id = undefined;
    this.url = undefined;
    this.nodeReference = undefined;
    this.nodes = undefined;
    this.navigationState = undefined;
    this.isPBS = undefined;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  render() {
    var _a, _b;
    return (h("a", { href: !this.isPBS ? this.url : '#', class: "range-node-link", onClick: (event) => {
        if (this.isPBS) {
          event.preventDefault();
          this.nodeSelected.emit({
            id: this.id,
            image: this.image,
            url: this.url,
            name: this.name,
            nodeReference: this.nodeReference,
            nodes: this.nodes,
            navigationState: this.navigationState,
          });
        }
      } }, h("div", { class: "range-node-card" }, h("div", { class: "range-node-card__img-wrapper" }, h("img", { src: (_a = this.image) === null || _a === void 0 ? void 0 : _a.url, alt: (_b = this.image) === null || _b === void 0 ? void 0 : _b.alt })), h("div", { class: "range-node-card__label-wrapper" }, h("p", { class: "range-node-card__label" }, this.name)))));
  }
  static get is() { return "pes-range-node-card"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["range-node-card.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["range-node-card.css"]
    };
  }
  static get properties() {
    return {
      "image": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "ImageLink",
          "resolved": "{ title?: string; url?: string; alt?: string; }",
          "references": {
            "ImageLink": {
              "location": "import",
              "path": "../types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "name": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "name",
        "reflect": false
      },
      "id": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "id",
        "reflect": false
      },
      "url": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "url",
        "reflect": false
      },
      "nodeReference": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "node-reference",
        "reflect": false
      },
      "nodes": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "Nodes[]",
          "resolved": "Nodes[]",
          "references": {
            "Nodes": {
              "location": "import",
              "path": "../types"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "navigationState": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "navigation-state",
        "reflect": false
      },
      "isPBS": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Defines whether the component is integrated to PBS."
        },
        "attribute": "is-p-b-s",
        "reflect": false
      }
    };
  }
  static get events() {
    return [{
        "method": "nodeSelected",
        "name": "nodeSelected",
        "bubbles": true,
        "cancelable": true,
        "composed": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "complexType": {
          "original": "RangeNode",
          "resolved": "{ id?: string; image?: ImageLink; name?: string; navigationState?: string; nodeReference?: string; url?: string; nodes?: Nodes[]; }",
          "references": {
            "RangeNode": {
              "location": "import",
              "path": "../types"
            }
          }
        }
      }];
  }
  static get elementRef() { return "el"; }
}
